var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.showFooter)?_c('div',{staticClass:"footer_container"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"site"},[_c('p',[_c('span',[_vm._v("Copyright©2022-2024 深圳市幸福生活未来科技有限公司版权所有")]),_c('a',{staticStyle:{"margin-left":"10px"},attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("粤ICP备2024197104号-1")])])])])
}]

export { render, staticRenderFns }